import React, { useEffect, useState } from "react";
import { sr } from "../api/serviceReports";

export default function SRAdminEngineers() {
  const [rows, setRows] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [saving, setSaving] = useState(false);

  const load = async () => setRows(await sr.engineers.list());
  useEffect(() => { load(); }, []);

  async function onAdd() {
    if (!name.trim()) return alert("Name required");
    await sr.engineers.add({ name: name.trim(), email: email.trim() || null, active: 1 });
    setName(""); setEmail(""); load();
  }

  async function toggleActive(r) {
    await sr.engineers.update(r.id, { ...r, active: r.active ? 0 : 1 });
    load();
  }

  function startEdit(r) {
    setEditingId(r.id);
    setEditName(r.name || "");
    setEditEmail(r.email || "");
  }

  function cancelEdit() {
    setEditingId(null);
    setEditName("");
    setEditEmail("");
  }

  async function saveEdit(id) {
    if (!editName.trim()) return alert("Name required");
    setSaving(true);
    try {
      await sr.engineers.update(id, { name: editName.trim(), email: editEmail.trim() || null, active: 1 });
      cancelEdit();
      load();
    } finally {
      setSaving(false);
    }
  }


  async function remove(r) {
    if (!window.confirm(`Delete engineer "${r.name}"? This cannot be undone.`)) return;
    try {
      await sr.engineers.remove(r.id);
      load();
    } catch (e) {
      if (e?.message === "409") {
        alert("Engineer is used by existing reports. Disable instead.");
      } else {
        alert("Delete failed.");
      }
    }
  }

  return (
    <div className="card">
      <h2>Engineers</h2>

      {/* Add new */}
      <div className="row">
        <input className="input" placeholder="Name" value={name} onChange={e => setName(e.target.value)} />
        <input className="input" placeholder="Email (optional)" value={email} onChange={e => setEmail(e.target.value)} />
        <button className="btn" onClick={onAdd}>Add</button>
      </div>

      <table className="table" style={{ marginTop: 16 }}>
        <thead>
          <tr><th>Name</th><th>Email</th><th>Status</th><th style={{ width: 220 }}></th></tr>
        </thead>
        <tbody>
          {rows.map(r => {
            const isEdit = editingId === r.id;
            return (
              <tr key={r.id}>
                <td>
                  {isEdit
                    ? <input className="input" value={editName} onChange={e => setEditName(e.target.value)} />
                    : r.name}
                </td>
                <td>
                  {isEdit
                    ? <input className="input" value={editEmail} onChange={e => setEditEmail(e.target.value)} />
                    : (r.email || "—")}
                </td>
                <td>
                  <span className="badge">{r.active ? "Active" : "Inactive"}</span>
                </td>
                <td style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                  {isEdit ? (
                    <>
                      <button className="btn" disabled={saving} onClick={() => saveEdit(r.id)}>
                        {saving ? "Saving..." : "Save"}
                      </button>
                      <button className="btn secondary" onClick={cancelEdit}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <button className="btn" onClick={() => startEdit(r)}>Edit</button>
                      <button className="btn" onClick={() => toggleActive(r)}>{r.active ? "Disable" : "Enable"}</button>
                      <button className="btn secondary" onClick={() => remove(r)}>Delete</button>
                    </>
                  )}
                </td>
              </tr>
            );
          })}
          {rows.length === 0 && (
            <tr><td colSpan={4} style={{ color: "#666", padding: 12 }}>No engineers yet.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
